import { useState } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import BaseRating from "../../../common/base-rating/base-rating";

//import view components
import MapModal from "../map-modal/map-modal";

//import images and icons
import noImage from "../../../../assets/imgs/no-image.png";
import locationOnMap from "../../../../assets/imgs/location-on-map.jpg";

import { Star1 } from "iconsax-react";

function TourHotel({ hotelItem, index }) {
    //general variables
    const { t } = useTranslation();

    //state to manage the visibility of the map modal
    const [isOpen, setIsOpen] = useState(false);

    // State to manage the state of the map modal, including latitude, longitude, and coordinates
    const [mapModalState, setMapModalState] = useState({
        latitude: null,
        longitude: null,
        coordinates: null,
    });

    //handles the opening of the map modal and sets the state for the map modal
    const handleMapModal = (lat, long) => {
        setIsOpen(true);
        const latitudeDelta = 180 / 2 ** 17;
        const longitudeDelta = 360 / 2 ** 17;

        // Calculates the bounds of the map view based on the provided latitude and longitude
        const southLatitude = lat - latitudeDelta;
        const northLatitude = lat + latitudeDelta;
        const westLongitude = long - longitudeDelta;
        const eastLongitude = long + longitudeDelta;

        const coordinates = {
            southLatitude,
            northLatitude,
            westLongitude,
            eastLongitude,
        };

        setMapModalState({
            latitude: lat,
            longitude: long,
            coordinates,
        });
    };

    return (
        <Grid className="recommended-hotel__card" key={Math.random()} container item xs={12} justifyContent="space-between">
            {!!index && <span className="recommended-hotel__index">{index}</span>}

            <Grid className="recommended-hotel__image-box" container item xs={12} md={4.5}>
                <img
                    className="recommended-hotel__hotel-image"
                    src={hotelItem?.images?.length ? "https://api.atripa.com" + hotelItem?.images[0]?.image : locationOnMap}
                    // src={exampleImage}
                    alt=""
                />
                <span
                    className="recommended-hotel__positioning"
                    onClick={() => handleMapModal(hotelItem?.accommodation?.latitude, hotelItem?.accommodation?.longitude)}
                >
                    {t("showMap")}
                </span>
            </Grid>

            <Grid
                className="recommended-hotel__details"
                container
                item
                xs={12}
                md={7.5}
                rowGap={1}
                columnGap={{ xs: 0, md: 1 }}
                justifyContent={{ xs: "space-between", md: "flex-start" }}
                alignItems="flex-start"
            >
                <Grid className="recommended-hotel__hotel-name" component="span" container item xs={12}>
                    {hotelItem?.accommodation?.english_name}
                </Grid>

                <Grid container item xs={12} justifyContent={{ xs: "flex-end", md: "flex-start" }}>
                    <BaseRating
                        value={hotelItem?.accommodation?.star}
                        icon={Star1}
                        emptyIcon={Star1}
                        color="var(--golden-color)"
                        size="20"
                        readOnly={true}
                    />
                </Grid>

                {hotelItem?.accommodation?.zone && (
                    <Grid container item xs={6} md={12} columnGap={1} alignItems="center">
                        <span className="recommended-hotel__zone">{t("region")}:</span>
                        <span>{hotelItem?.accommodation?.zone}</span>
                        <span className="recommended-hotel__zone-value">{hotelItem?.accommodation?.zone}</span>
                    </Grid>
                )}

                <Grid container item xs={6} md={12} columnGap={1} alignItems="center">
                    <span className="recommended-hotel__access-type">{t("typeOfAccess")}:</span>
                    <span className="recommended-hotel__access-type-value">{t("urban")}</span>

                    {/* <span className="recommended-hotel__access-type-value">{hotelItem?.accommodation?.access_type}</span> */}
                </Grid>
            </Grid>

            <MapModal open={isOpen} setOpen={setIsOpen} mapModalState={mapModalState} />
        </Grid>
    );
}

export default TourHotel;
